module.exports = __webpack_public_path__ + "fonts/default@2x.ce86307f9d783efd37af35b190bb3642.png?";


//////////////////
// WEBPACK FOOTER
// ./~/@okta/okta-signin-widget/dist/img/security/default@2x.png
// module id = 814
// module chunks = 9